const emergencyBn = {
	buttons: {
		gas: 'গ্যাস সিলিন্ডার',
		medicine: 'জরুরি ঔষধ',
	},
	common: {
		nameLabel: 'আপনার নাম',
		phoneLabel: 'মোবাইল নাম্বার',
		villageLabel: 'গ্রাম/এলাকা',
		houseNumberLabel: 'বাড়ি নম্বর',
		detailsLabel: 'অতিরিক্ত তথ্য',
		detailsPlaceholder: 'যদি কোন বিশেষ নির্দেশনা থাকে',
		districtLabel: 'জেলা',
		upazillaLabel: 'উপজেলা',
		cancel: 'বাতিল করুন',
	},
	gas: {
		title: 'গ্যাস সিলিন্ডার রিফিল',
		companyLabel: 'গ্যাস কোম্পানি',
		cylinderSizeLabel: 'সিলিন্ডারের সাইজ',
		cylinderSizePlaceholder: 'সিলিন্ডারের সাইজ নির্বাচন করুন',
		quantityLabel: 'সংখ্যা',
		companies: {
			bashundhara: 'বসুন্ধরা গ্যাস',
			jamuna: 'যমুনা গ্যাস',
			omera: 'ওমেরা গ্যাস',
			beximco: 'বেক্সিমকো গ্যাস',
			fresh: 'ফ্রেশ গ্যাস',
			totalgaz: 'টোটাল গ্যাজ',
			others: 'অন্যান্য',
		},
		cylinderSizeOptions: {
			"12kg": '১২ কেজি',
			"33kg": '৩৩ কেজি',
			"45kg": '৪৫ কেজি',
		},
		price: {
			header: 'মূল্য বিবরণ',
			unitPrice: 'একক মূল্য',
			subtotal: 'সাবটোটাল',
			delivery: 'ডেলিভারি চার্জ',
			total: 'মোট মূল্য',
			note: '* ক্যাশ অন ডেলিভারি সুবিধা আছে',
			unitSuffix: 'টি',
		},
		orderNow: 'অর্ডার করুন',
	},
	medicine: {
		title: 'জরুরি ঔষধ সেবা',
		medicineNameLabel: 'ঔষধের নাম',
		medicineNamePlaceholder: 'কোন ঔষধ প্রয়োজন?',
		urgencyLabel: 'জরুরত্বের মাত্রা',
		urgencyOptions: {
			normal: 'সাধারণ',
			urgent: 'জরুরি',
			emergency: 'অতি জরুরি',
		},
		prescriptionLabel: 'প্রেসক্রিপশন (যদি থাকে)',
		prescriptionPlaceholder: 'ডাক্তারের প্রেসক্রিপশন বা ঔষধের বিবরণ',
		uploadNote: 'প্রেসক্রিপশন আপলোড ঐচ্ছিক; ছবি বা PDF ফাইল দিতে পারেন।',
		uploadButton: 'প্রেসক্রিপশন আপলোড করুন (ঐচ্ছিক)',
		selectedFilePrefix: 'নির্বাচিত ফাইল:',
		submit: 'জরুরি অর্ডার করুন',
	}
};

export default emergencyBn;


